
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import $ from 'jquery';
let Base64 = require('js-base64').Base64
import tabbar from '@/components/tabbar'
export default{
components: {
Group,
tabbar,
XButton,
Cell,
Confirm,
},
data(){
return{
phone:"",
ownerData:{},
show:false
}
},
mounted(){
this.getUDatas();
},
methods:{
onCancel () {
},
onConfirm (msg) {
this.$vux.loading.show({
text: '登出中'
})
let that=this;
let loginData=JSON.parse(localStorage.getItem("loginData"));
let accessToken=loginData.access_token;
let token=loginData.token_type+" "+loginData.access_token;
$.ajax({
url : this._Api.loginUrl,
type: "DELETE",
contentType: "application/json;charset=utf-8",
data:JSON.stringify({"accessToken":accessToken}),
beforeSend: function(xhr) {
xhr.setRequestHeader("Authorization", "Basic d2ViQXBwOndlYkFwcA==");
},
success: function(res) {
that.$vux.loading.hide()
localStorage.removeItem('loginData');
that.$router.push({
path: '/'
});
},

error:function(res){
that.$vux.loading.hide()
localStorage.removeItem('loginData');
that.$router.push({
path: '/'
});

}

});























},
relogin() {
this.show=true;
},
getUDatas(){
let loginData = JSON.parse(localStorage.getItem('loginData'));
let ownerData =JSON.parse(localStorage.getItem('ownerData'));
this.phone=loginData.usename;
if(ownerData){
this.ownerData=ownerData
}else{
this.ownerData={
ownerName:"暂时无会员信息"
}
}
},
}
}



// WEBPACK FOOTER //
// ./src/pages/userCenter.vue